module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'menu'
      }
    }
  }, [_vm._v("资源树")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.menurules,
      "label-width": "120px",
      "label-position": _vm.labelposition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "菜单名称",
      "label-width": _vm.formLabelWidth,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单url",
      "label-width": _vm.formLabelWidth,
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单序号",
      "label-width": _vm.formLabelWidth,
      "prop": "order"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.order),
      callback: function($$v) {
        _vm.$set(_vm.form, "order", $$v)
      },
      expression: "form.order"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单编号",
      "label-width": _vm.formLabelWidth,
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单描述",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否是菜单",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.form.isMenu),
      callback: function($$v) {
        _vm.$set(_vm.form, "isMenu", $$v)
      },
      expression: "form.isMenu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority Name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.authorityName),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorityName", $$v)
      },
      expression: "form.authorityName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority Url",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.requestUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "requestUrl", $$v)
      },
      expression: "form.requestUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority Method",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.requestMethod),
      callback: function($$v) {
        _vm.$set(_vm.form, "requestMethod", $$v)
      },
      expression: "form.requestMethod"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority Params",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.requestParams),
      callback: function($$v) {
        _vm.$set(_vm.form, "requestParams", $$v)
      },
      expression: "form.requestParams"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.redrictTree
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a187f604!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/menu/MenuEdit.vue
// module id = 1089
// module chunks = 2